import { BidderCampaign } from '../../pages/bidder/campaigns/index/bidder.campaign';
import { EditBidderCampaign } from '../../pages/bidder/campaigns/edit/edit-bidder-campaign.page';
import routes from '../routes/index.routes';
import { CreateBidderCampaign } from '../../pages/bidder/campaigns/create/create-bidder-campaign.page';
import { DuplicateBidderCampaign } from '../../pages/bidder/campaigns/duplicate/duplicate-bidder-campaign.page';
import { BidderModels } from '../../pages/bidder/models/bidder-models.page';
import { EditBidderModel } from '../../pages/bidder/models/edit/edit-bidder-model.page';
import { BidderUpdateMaxLossClicksPage } from '../../pages/bidder/update-max-loss-clicks/update-max-loss-clicks.page';

export const BidderRouter = [
	{
		path: routes.bidder.editModel(':modelName'),
		element: <EditBidderModel />,
	},
	{
		path: routes.bidder.models(),
		element: <BidderModels />,
	},
	{
		path: routes.bidder.campaigns(),
		element: <BidderCampaign />,
	},
	{
		path: routes.bidder.updateMaxLossClicks(),
		element: <BidderUpdateMaxLossClicksPage />,
	},
	{
		path: routes.bidder.createCampaign(),
		element: <CreateBidderCampaign />,
	},
	{
		path: routes.bidder.editCampaign(':bidderCampaignId'),
		element: <EditBidderCampaign />,
	},
	{
		path: routes.bidder.duplicateCampaign(':bidderCampaignId'),
		element: <DuplicateBidderCampaign />,
	},
];
